import React from 'react';
import { useLanguage } from '../LanguageContext'; // ✅ import

const Hero = () => {
  const { language } = useLanguage(); // ✅ use it

  return (
    <section className="bg-custom-hero text-black text-center py-20 px-4">
      <h1 className="text-4xl md:text-5xl font-bold mb-4">
        {language === 'id' ? 'Layanan Desain Website Harga Terjangkau' : 'Affordable Website Design Services'}
      </h1>
      <h2 className="text-4xl md:text-5xl font-bold mb-4">
        {language === 'id' ? 'Waktu Adalah Uang, Serahkan Semua ke kami!' : 'Save Your Time & Money, Leave it with us!'}
      </h2>
      <p className="text-lg md:text-xl mb-6">
        {language === 'id'
          ? 'Cocok untuk bisnis kecil, freelance, dan pemula'
          : 'Perfect for small businesses, freelancers, and startups'}
      </p>
      <a
        href="#pricing"
        className="inline-block bg-blue-600 text-white px-6 py-3 rounded shadow hover:bg-blue-700 transition animate-bounce"
      >
        {language === 'id' ? 'Lihat Paket' : 'View Packages'}
      </a>
    </section>
  );
};

export default Hero;
